import script from "./informationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./informationDialog.vue?vue&type=script&lang=ts&setup=true"

import "./informationDialog.vue?vue&type=style&index=0&id=13c5ccfb&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c5ccfb"]])

export default __exports__